import Icon from '../../components/Icon.vue'

Icon.register({"brands/kickstarter-k":{"width":384,"height":512,"paths":[{"d":"M147.3 114.4C147.3 58.2 114.8 32 73.9 32 26.2 32 0 68.2 0 113.4V396.4C0 443.7 25.3 479.8 74.9 479.8 114.7 479.8 147.3 454.2 147.3 396.4V319.9L259.4 458.2C282.1 485.4 331.5 488.9 362.6 458.2 389.6 430.6 389.9 390.8 370 366L279.2 251.2 354.1 143.8C371.5 119.1 371.6 80.7 343.7 54 313.4 25 261.3 22.4 230.1 66.8L147.3 185V114.4z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/brands/kickstarter-k.js
// module id = null
// module chunks = 